import { PageLocatorMap } from '../types/PageLocatorMap';

export const signUpPage = {
  alert: {
    error: 'signup-page.alert.error',
  },
  footer: {
    root: 'signup-page.footer.root',
  },
  form: {
    emailInput: 'signup-page.form.email-input',
    emailInputError: 'signup-page.form.email-error',
    firstNameInput: 'signup-page.form.first-name-input',
    firstNameInputError: 'signup-page.form.first-name-error',
    h1: 'signup-page.form.heading1',
    h2: 'signup-page.form.heading2',
    lastNameInput: 'signup-page.form.last-name-input',
    lastNameInputError: 'signup-page.form.last-name-error',
    phoneInput: 'signup-page.form.phone-input',
    phoneInputError: 'signup-page.form.phone-error',
    privacyLink: 'signup-page.form.privacy-link',
    reviewsLink: 'signup-page.form.reviews-link',
    root: 'signup-page.form.root',
    smsOptInCheckbox: 'signup-page.form.sms-opt-in-checkbox',
    smsOptInCheckboxError: 'signup-page.form.sms-opt-in-error',
    submitButton: 'signup-page.form.submit-button',
    termsLink: 'signup-page.form.terms-link',
  },
  header: {
    root: 'signup-page.header.root',
    signInLink: 'signup-page.header.signin-link',
  },
} as const satisfies PageLocatorMap;
